import React, { useState } from 'react';
import { appToast } from '../../../../components/AppToast';

export default function UploadSalaryFileModal({ isOpen, onClose, onSuccess }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  if (!isOpen) return null;

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleUpload = () => {
    if (!selectedFile) {
      appToast.error('Please select an Excel or CSV file to upload.');
      return;
    }

    setIsUploading(true);
    setTimeout(() => {
      setIsUploading(false);
      appToast.success(`File "${selectedFile.name}" processed successfully! 12 salary records imported.`);
      onSuccess?.();
      onClose();
    }, 1200);
  };

  const handleDownloadSample = () => {
    appToast.info('Downloading sample salary Excel template...');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-xs p-4 animate-in fade-in duration-150">
      <div className="w-full max-w-lg rounded-2xl border border-outline-variant/30 bg-surface-container-lowest p-6 shadow-2xl space-y-6">
        
        {/* Modal Header */}
        <div className="flex items-center justify-between border-b border-outline-variant/20 pb-4">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
              <span className="material-symbols-outlined text-2xl">cloud_upload</span>
            </div>
            <div>
              <h3 className="text-base font-bold text-on-surface">
                Upload File To Process Salary
              </h3>
              <p className="text-xs text-on-surface-variant font-medium">
                Import bulk monthly salary, bonuses, and deduction sheets.
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="h-8 w-8 rounded-lg text-on-surface-variant hover:bg-surface-container-high hover:text-on-surface flex items-center justify-center transition cursor-pointer"
          >
            <span className="material-symbols-outlined text-lg">close</span>
          </button>
        </div>

        {/* Modal Body */}
        <div className="space-y-4">
          <div className="rounded-xl border-2 border-dashed border-outline-variant/60 bg-surface-container-low/50 p-6 text-center hover:border-primary/50 transition">
            <input
              type="file"
              id="salary-upload-input"
              accept=".csv,.xlsx,.xls"
              onChange={handleFileChange}
              className="hidden"
            />
            <label htmlFor="salary-upload-input" className="cursor-pointer flex flex-col items-center gap-2">
              <span className="material-symbols-outlined text-4xl text-primary/80">
                upload_file
              </span>
              <span className="text-xs font-bold text-on-surface">
                {selectedFile ? selectedFile.name : 'Click to select CSV or Excel sheet'}
              </span>
              <span className="text-[11px] text-on-surface-variant">
                Supported formats: .XLSX, .XLS, .CSV (Max 15MB)
              </span>
            </label>
          </div>

          <div className="flex items-center justify-between rounded-xl bg-surface-container-low p-3 text-xs">
            <span className="text-on-surface-variant font-medium">Need the standard payroll template?</span>
            <button
              type="button"
              onClick={handleDownloadSample}
              className="text-primary font-bold hover:underline flex items-center gap-1 cursor-pointer"
            >
              <span className="material-symbols-outlined text-sm">download</span>
              <span>Sample Template</span>
            </button>
          </div>
        </div>

        {/* Modal Actions */}
        <div className="flex items-center justify-end gap-3 border-t border-outline-variant/20 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-5 py-2.5 rounded-xl bg-surface-container-high hover:bg-surface-container-highest text-on-surface text-xs font-bold transition cursor-pointer"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleUpload}
            disabled={isUploading || !selectedFile}
            className="px-6 py-2.5 rounded-xl bg-primary hover:bg-primary/90 text-on-primary text-xs font-bold shadow-sm transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 cursor-pointer"
          >
            {isUploading ? (
              <>
                <span className="material-symbols-outlined text-sm animate-spin">progress_activity</span>
                <span>Processing...</span>
              </>
            ) : (
              <>
                <span className="material-symbols-outlined text-sm">upload</span>
                <span>Upload & Process</span>
              </>
            )}
          </button>
        </div>

      </div>
    </div>
  );
}
